module.exports = __webpack_public_path__ + "img/linkseinfuegen.6dbd01c.svg";